export { default } from "./App";



// WEBPACK FOOTER //
// ./src/containers/App/index.js